export const gallery = {
  title: "A vida em Gándara",
  subtitle: "Um espaço para crescer, explorar e descobrir"
};
